{
    "title": "Ask Plato",
    "trigger": "Ask Plato",
    "close": "Close Ask Plato",
    "send": "Send",
    "scroll_to_bottom": "Scroll to bottom",
    "thinking": "Thinking…",
    "placeholder": "Ask about customers, revenue, tasks…",
    "error": "Something went wrong.",
    "like": "Like this answer",
    "dislike": "Dislike this answer",
    "copy": "Copy",
    "copied": "Copied",
    "disclaimer": "Ask Plato is experimental and can make mistakes. Please verify important information.",
    "ask_support": "Contact support",
    "retry": "Try again",
    "support_message": "Ask Plato could not answer this question:\n\n{{question}}\n\n",
    "error_explanation": "I'm having a technical problem right now. Try again later or contact our support directly.",
    "welcome": "Hi! I know your customers, orders and activities. What would you like to know?",
    "teaser": "Questions? Plato can help!",
    "teaser_dismiss": "Dismiss hint",
    "home_card__subtitle": "I know your customers, orders and activities. What would you like to know?",
    "home_card__greeting_morning": "Good morning, {{name}}",
    "home_card__greeting_day": "Good afternoon, {{name}}",
    "home_card__greeting_evening": "Good evening, {{name}}",
    "home_card__starter_visit_prep_label": "Prepare customer event",
    "home_card__starter_visit_prep": "Prepare me for my event with {{caret}}",
    "home_card__starter_revenue_decline": "Which of my customers are losing revenue, and why?",
    "home_card__starter_revenue_vs_last_year": "How is my revenue this year compared to last year?",
    "home_card__starter_revenue_decline_label": "Customers losing revenue",
    "home_card__starter_revenue_vs_last_year_label": "My revenue vs. last year",
    "new_chat": "New chat",
    "context_limit_reached": "Conversation limit reached.",
    "context_limit_reached_explanation": "This conversation has reached its length limit. Start a new chat to continue.",
    "start_new_chat": "Start a new chat",
    "history": "History",
    "history_empty": "No conversations yet.",
    "back": "Back to chat",
    "history_today": "Today",
    "history_yesterday": "Yesterday",
    "history_last_7_days": "Last 7 days",
    "history_older": "Older",
    "tool__generic__running": "Working on it",
    "tool__generic__done": "Looked up your business data",
    "tool__failed": "Couldn't retrieve this data",
    "tool__interrupted": "Interrupted before finishing",
    "tool__find_plato_page__running": "Looking up where to find this in Plato",
    "tool__find_plato_page__done": "Looked up where to find this in Plato",
    "tool__get_customer_notes__running": "Reading notes",
    "tool__get_customer_notes__done": "Read notes",
    "tool__get_customer_notes__done_search": "Read notes matching “{{search}}”",
    "tool__get_pinned_customer_notes__running": "Reading pinned notes",
    "tool__get_pinned_customer_notes__done": "Read pinned notes",
    "tool__get_note__running": "Reading a note",
    "tool__get_note__done": "Read the note",
    "tool__get_data_freshness__running": "Checking how current the data is",
    "tool__get_data_freshness__done": "Checked how current the data is",
    "tool__get_daily_order_intake__running": "Checking today's and yesterday's order intake",
    "tool__get_daily_order_intake__done": "Checked today's and yesterday's order intake",
    "tool__get_sales_summary__running": "Reading the year-to-date sales summary",
    "tool__get_sales_summary__done": "Read the year-to-date sales summary",
    "tool__get_sales_totals__running": "Computing sales totals",
    "tool__get_sales_totals__done": "Computed sales totals",
    "tool__get_monthly_trend__running": "Fetching the monthly revenue trend",
    "tool__get_monthly_trend__done": "Fetched the monthly revenue trend",
    "tool__get_revenue_by_year__running": "Comparing revenue across years",
    "tool__get_revenue_by_year__done": "Compared revenue across years",
    "tool__get_top_customers__running": "Ranking customers",
    "tool__get_top_customers__done": "Ranked customers",
    "tool__get_top_customers__done_search": "Ranked customers matching “{{search}}”",
    "tool__get_top_products__running": "Ranking products",
    "tool__get_top_products__done": "Ranked products",
    "tool__get_top_products__done_search": "Ranked products matching “{{search}}”",
    "tool__get_top_product_groups__running": "Ranking product groups",
    "tool__get_top_product_groups__done": "Ranked product groups",
    "tool__get_top_product_groups__done_search": "Ranked product groups matching “{{search}}”",
    "tool__get_top_categories__running": "Ranking merchandise groups",
    "tool__get_top_categories__done": "Ranked merchandise groups",
    "tool__get_top_categories__done_search": "Ranked merchandise groups matching “{{search}}”",
    "tool__get_top_suppliers__running": "Ranking suppliers",
    "tool__get_top_suppliers__done": "Ranked suppliers",
    "tool__get_top_suppliers__done_search": "Ranked suppliers matching “{{search}}”",
    "tool__get_top_clerks__running": "Ranking clerks",
    "tool__get_top_clerks__done": "Ranked clerks",
    "tool__get_top_clerks__done_search": "Ranked clerks matching “{{search}}”",
    "tool__get_top_sales_reps__running": "Ranking sales reps",
    "tool__get_top_sales_reps__done": "Ranked sales reps",
    "tool__get_top_sales_reps__done_search": "Ranked sales reps matching “{{search}}”",
    "tool__get_top_storage_locations__running": "Ranking storage locations",
    "tool__get_top_storage_locations__done": "Ranked storage locations",
    "tool__get_top_storage_locations__done_search": "Ranked storage locations matching “{{search}}”",
    "tool__get_top_industries__running": "Ranking industries",
    "tool__get_top_industries__done": "Ranked industries",
    "tool__get_top_industries__done_search": "Ranked industries matching “{{search}}”",
    "tool__get_customer_details__running": "Reading customer details",
    "tool__get_customer_details__done": "Read customer details",
    "tool__get_customer_financials__running": "Reading customer financials",
    "tool__get_customer_financials__done": "Read customer financials",
    "tool__get_customer_segment_aggregates__running": "Aggregating a customer segment",
    "tool__get_customer_segment_aggregates__done": "Aggregated the customer segment",
    "tool__get_quotes_orders_aggregates__running": "Summing up quotes and orders",
    "tool__get_quotes_orders_aggregates__done": "Summed up quotes and orders",
    "tool__get_team_members__running": "Loading the team roster",
    "tool__get_team_members__done": "Loaded the team roster",
    "tool__get_team_overview__running": "Compiling the team activity overview",
    "tool__get_team_overview__done": "Compiled the team activity overview",
    "tool__get_team_overview__done_search": "Compiled the team activity overview for “{{search}}”",
    "tool__get_team_stats__running": "Computing the team totals",
    "tool__get_team_stats__done": "Computed the team totals",
    "tool__get_team_stats__done_search": "Computed the team totals for “{{search}}”"
}
